import React from 'react';
import { Stack, Skeleton } from '@mui/material';
import styles from './FlowRunItem.module.scss';

export const FlowRunItemSkeleton: React.FC = () => {
  return (
    <div className={styles.flowRunItem}>
      <Stack direction="column" gap="4px" flex={1}>
        <Skeleton variant="text" width="60%" height={20} />
        <Stack direction="row" alignItems="center" gap="8px">
          <Skeleton variant="text" width={80} height={16} />
          <Skeleton variant="text" width={100} height={16} />
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" gap="16px" className={styles.runMetrics}>
        <Stack direction="column" alignItems="flex-end">
          <Stack direction="row" alignItems="center" gap="8px">
            <Skeleton variant="text" width={50} height={16} />
          </Stack>
        </Stack>
        <Skeleton variant="rectangular" width={80} height={24} />
      </Stack>
    </div>
  );
};
